var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 26,
    fill: "none",
    viewBox: "0 0 21 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.175,
    height: 22.314,
    x: 5.352,
    y: 0.448,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.75,
    rx: 1.625,
    transform: "rotate(12.694 5.352 .448)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.175,
    height: 22.314,
    x: 2.714,
    y: 1.843,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    rx: 1.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.316 15.197H5.975c-.204 0-.34.136-.34.34 0 .204.136.34.34.34h8.307c.205 0 .34-.136.34-.34 0-.204-.135-.34-.306-.34zM14.316 17.07H5.975c-.204 0-.34.135-.34.34 0 .204.136.34.34.34h8.307c.205 0 .34-.136.34-.34 0-.205-.135-.34-.306-.34zM14.316 18.942H5.975c-.204 0-.34.136-.34.34 0 .204.136.34.34.34h8.307c.205 0 .34-.136.34-.34 0-.204-.135-.34-.306-.34zM9.878 20.688H5.8c-.1 0-.167.11-.167.275 0 .164.067.274.167.274h4.06c.1 0 .167-.11.167-.274 0-.165-.067-.275-.15-.275zM14.046 7.07h-1.698V5.372c0-.234-.196-.43-.43-.43H9.147c-.235 0-.43.196-.43.43V7.07H7.02c-.234 0-.43.195-.43.43v2.77c0 .235.196.43.43.43h1.698v1.698c0 .234.195.43.43.43h2.771c.234 0 .43-.196.43-.43V10.7h1.698c.234 0 .429-.195.429-.43V7.5c0-.255-.195-.43-.43-.43zm-.41 2.771h-1.698c-.235 0-.43.195-.43.43v1.698H9.576V10.27c0-.235-.195-.43-.43-.43H7.45V7.91h1.698c.234 0 .429-.195.429-.43V5.783h1.932V7.48c0 .234.195.429.43.429h1.698v1.932z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6400",
    d: "M13.636 9.841h-1.698c-.235 0-.43.195-.43.43v1.698H9.576V10.27c0-.235-.195-.43-.43-.43H7.45V7.91h1.698c.234 0 .429-.195.429-.43V5.783h1.932V7.48c0 .234.195.429.43.429h1.698v1.932z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIconActive);
export default __webpack_public_path__ + "static/media/documents-icon-active.6e09cfd354d145b37c7dddef048a1774.svg";
export { ForwardRef as ReactComponent };